/** Per-row callbacks for the row menu, bound to one task. */
export type TaskRowMenuHandlers = {
  onSnooze?: () => void;
  onDelete?: () => void;
};

/**
 * Bind table-level row-menu callbacks to one row's task. A missing callback
 * stays missing, so the menu hides that item.
 */
export function bindTaskRowMenuHandlers<TTask>(
  task: TTask,
  handlers: {
    onSnooze?: (task: TTask) => void;
    onDelete?: (task: TTask) => void;
  },
): TaskRowMenuHandlers {
  const { onSnooze, onDelete } = handlers;
  return {
    onSnooze: onSnooze && (() => onSnooze(task)),
    onDelete: onDelete && (() => onDelete(task)),
  };
}
